import { TableCard } from '../../../../components'
import { ClienteHeading } from '../empresasCliente-list/components/ClienteHeading'
import { CargoClienteListHeader } from './components/header/CargoClienteListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { CargoClienteTable } from './table/CargoClienteTable'

const CargoClienteList = () => {
  return (
    <>
      <ClienteHeading />
      <TableCard>
        <CargoClienteListHeader />
        <CargoClienteTable />
      </TableCard>
    </>
  )
}

export const CargoClienteListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <CargoClienteList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
